import { Space } from 'antd'
import { AvatarStatus } from 'components/elements/AvatarStatus'
import { BaseButton } from 'components/elements/BaseButton'
import { useReadChatMessageMutation } from 'features/chat/api'
import useChat from 'features/chat/hooks/useChat'
import { updateChatListById } from 'features/chat/reducer/ChatSlice'
import { TChatListData } from 'features/chat/types'
import { useAppDispatch } from 'hooks'
import useAuth from 'hooks/useAuth'
import { FC } from 'react'
import { useNavigate } from 'react-router'

const ChatMessageHeader: FC<{
 data?: TChatListData
 leadId?: string | number
}> = ({ data, leadId }) => {
 const dispatch = useAppDispatch()
 const { user } = useAuth()
 const { removeFromChatList } = useChat()

 const [readChatMessage] = useReadChatMessageMutation()

 const messageRead = async (id: number) => {
  await readChatMessage({ chat_id: id }).unwrap()
 }
 const navigate = useNavigate()

 const subTitle = data?.transferowner
  ? `${user?.account_type === 'Brokerage' ? 'Assigned To' : 'Assigned By'} ${
     data?.transferowner
    }`
  : ''

 return (
  <div className="chat-messenger-header">
   <div
    aria-hidden="true"
    tabIndex={0}
    role="button"
    className="com-item-hd-content cursor-pointer"
    onClick={() => {
     if (leadId) {
      navigate({ hash: `lead-details/${leadId}/profile` })
     }
    }}
   >
    <AvatarStatus
     avatar={{ size: 35 }}
     title={data?.leadName || ''}
     subTitle={subTitle}
     //  link={`#lead-details/${leadId}/profile`}
    />
   </div>
   <div className="com-item-hd-action">
    <Space size={3} align="center">
     <BaseButton
      title="Minimize"
      size="small"
      type="link"
      className="px-1"
      icon={<i className="fas fa-minus" />}
      onClick={() => {
       /* 
        Since we only have 'updateChatList' with strict payload now, 
        and 'updateChatListById' is meant for internal updates or specific field patches,
        we can use 'updateChatListById' if we want to patch 'minimized', 
        OR use 'updateChatList' if we want to re-open/update.
        But here we want to minimize.
        Given the refactor plan kept 'updateChatListById' for these cases, we use it.
       */
       dispatch(
        updateChatListById({
         id: data?.id,
         data: {
          minimized: true,
          unReadCount: 0,
         },
        }),
       )
       if (Number(data?.unReadCount ?? 0) > 0) {
        messageRead(data?.id)
       }
      }}
     />
     <BaseButton
      className="px-1"
      title="Close"
      onClick={() => {
       // payload type check: id is any, type is 'direct' | 'other'
       removeFromChatList?.({ id: data?.id })
       if (Number(data?.unReadCount ?? 0) > 0) {
        messageRead(data?.id)
       }
      }}
      size="small"
      type="link"
      icon={<i className="fas fa-times" />}
     />
    </Space>
   </div>
  </div>
 )
}

export default ChatMessageHeader
